import React from "react";
import {Spinner} from "react-bootstrap";

import "./Button.css";

const VARIANT_CLASS = {
    primary: "nco-btn-primary",
    secondary: "nco-btn-ghost",
    soft: "nco-btn-soft",
    danger: "nco-btn-danger",
    link: "ui-btn-link",
};

export default function Button({
    ref,
    variant = "secondary",
    size = "sm",
    icon = null,
    loading = false,
    fullWidth = false,
    type = "button",
    disabled = false,
    className = "",
    children,
    ...rest
}) {
    const classes = [
        "nco-btn",
        "ui-btn",
        VARIANT_CLASS[variant] ?? VARIANT_CLASS.secondary,
        size === "md" ? "ui-btn-md" : "nco-btn-sm",
        fullWidth && "ui-btn-full",
        loading && "ui-btn-loading",
        className,
    ].filter(Boolean).join(" ");

    return (
        <button
            ref={ref}
            type={type}
            className={classes}
            disabled={disabled || loading}
            aria-busy={loading || undefined}
            {...rest}
        >
            <span className="ui-btn-label">
                {icon && <span className="ui-btn-icon" aria-hidden="true">{icon}</span>}
                {children}
            </span>
            {loading && (
                <span className="ui-btn-spinner">
                    <Spinner animation="border" size="sm" role="status"/>
                </span>
            )}
        </button>
    );
}
